import type {
  CompletedCalculationTactic,
  LoadFlowScenarioInputs
} from '../../..';
import { ActivePower } from '../../../domain/ActivePower';
import { Load } from '../../../domain/Load';
import { ReactivePower } from '../../../domain/ReactivePower';

export function findLoad(
  connectedToId: string,
  calculationTactic: CompletedCalculationTactic,
  loadFlowInputs: LoadFlowScenarioInputs
): Load {
  const loadInputPoint =
    calculationTactic.calculationSetResult.grid.functional.loadInputPoints.find(
      loadInputPoint => loadInputPoint.connectedToId === connectedToId
    );
  const load = loadFlowInputs.loads.find(
    load => load.id === loadInputPoint?.id
  );

  return new Load(
    ActivePower.fromWattNumber(load?.p),
    ReactivePower.fromVarNumber(load?.q),
    load?.loadSource
  );
}
